import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import slugify from 'slugify'

import K from '../K'

Vue.use(Vuex)

function toIso (str) {
  return slugify((str || '').toLowerCase())
}

export default {
  namespaced: true,
  state: {
    isLoaded: false,
    isPartner: false,
    partnerId: null,
    currentOffer: null,
    faqs: [], // {title, content}
    title: 'Votre jardin réinventé par un paysagiste',
    call2action: 'Démarrer<br/>mon<br/>projet',
    description: 'Une communauté de paysagistes passionés pour dessiner le jardin de vos rêves en fonction de votre style et de vos envies.',
    human: {
      src: '',
      srcLazy: '',
      text: ''
    },
    offers: {
      title: 'Nos Offres',
      list: []
    },
    contact: {
      title: 'Un service de confiance',
      text: 'HortusBox, c\'est un service humain et toujours à votre écoute. Déjà plusieurs centaines de clients qui nous ont fait déjà confiance. N\'hésitez pas à nous contacter avant ou pendant votre projet.',
      call2action: 'Contact'
    },
    founder: {
      title: 'Les Fondateurs',
      text: 'Les fondateurs Anahita et Pacôme<br/>Passionnés par le jardinage autant que par l\'informatique, nous avons décidé de rapprocher ces deux univers en créant une application de paysagisme afin d\'aider les particuliers à embellir leur jardin ou balcon à moindre coût et sans connaissance préalable.',
      src: '/gimc/storage/assets/fondateurs.png?format=jpeg&height=300',
      srcLazy: '/gimc/storage/assets/fondateurs.png?thumb=true',
      more2action: 'En apprendre plus sur nous'
    },
    contactPage: {
      title: 'Contact',
      logoUrl: '',
      logoLazyUrl: '',
      description: '',
      email: '',
      phone: '',
      moreDesc: ''
    },
    keepInTouch: {
      title: 'Restons en contact',
      description: 'Inscrivez vous à notre newsletter pour être les premiers à recevoir de nouvelles offres et de conseils réguliers.',
      pictureUrl: '',
      pictureLazyUrl: '',
    },    
    promo: {
      isActive: false,
      messageAdvert: '',
      messageWithCode: '',
      partners: [''],
      offers: [''],
      label: '',
      discount: 0
    }
  },
  getters: {
    contactPage: state => state.contactPage,
    title: state => state.title,
    call2action: state => state.call2action,
    description: state => state.description,
    human: state => state.human,
    offers: state => state.offers,
    contact: state => state.contact,
    founder: state => state.founder,
    currentOffer: state => state.currentOffer,
    keepInTouch: state => state.keepInTouch,
    faqs: state => state.faqs,
    promo: state => state.promo,
    promoIsActive: state => {
      if (!state.promo.isActive) {
        return false
      }
      return state.promo.partners.includes(state.partnerId)
    },
    promoIsActiveForOffer: state => id => {
      if (!state.promo.isActive) {
        return false
      }
      if (!state.promo.discount) {
        return false
      }
      if (!state.promo.partners.includes(state.partnerId)) {
        return false
      }

      return state.promo.offers.includes(id)
    }
  },
  mutations: {
    isLoaded (state) {
      state.isLoaded = true
    },
    setIsPartner (state, args) {
      state.isPartner = args
    },
    setPartnerId (state, args) {
      state.partnerId = args
    },
    updateCurrentOffer (state, iso) {
      state.offers.list.forEach(one => {
        if (one.iso === iso) {
          localStorage.setItem(K.projectCurrent, iso)
          localStorage.setItem(K.projectProductId, one.code)
          state.currentOffer = one
        }
      })
    },
    setFaqs (state, args) {
      state.faqs = args.map(item => ({
        title: item.Question,
        content: item.Answer
      }))
    },
    setContact (state, args) {
      state.contactPage = {
        title: args.Title,
        logoUrl: args.Logo.url,
        logoLazyUrl: args.Logo.formats.thumbnail.url,
        description: args.Description,
        email: args.Email,
        phone: args.Phone,
        moreDesc:args.MoreDesc
      }
    },
    setWebApp (state, args) {
      state.title = args.Title
      state.call2action = args.CallToAction
      state.description = args.Description
      state.human = {
        src: args.HumanPicture.url,
        srcLazy: args.HumanPicture.formats.thumbnail.url,
        text: args.HumanText
      },
      state.contact = {
        title: args.Contact.Title,
        text: args.Contact.Text,
        call2action: args.Contact.CallToAction
      },
      state.founder = {
        title: args.Founder.Title,
        text: args.Founder.Text,
        src: args.Founder.Picture.url,
        srcLazy: args.Founder.Picture.formats.thumbnail.url,
        more2action: args.Founder.MoreAction,
      }
      state.offers = {
        title: args.OffersTitle,
        list: []
      }
      state.keepInTouch = {
        title: args.KeepInTouch.Title,
        description: args.KeepInTouch.Description,
        pictureUrl: args.KeepInTouch.Picture.url,
        pictureLazyUrl: args.KeepInTouch.Picture.formats?.thumbnail?.url ? args.KeepInTouch.Picture.formats.thumbnail.url : args.KeepInTouch.Picture.url,
      }
      
      state.promo = {
        isActive: args.Promo.IsActive,
        messageAdvert: args.Promo.MessageAdvert,
        messageWithCode: args.Promo.MessageWithCode,
        partners: args.Promo.Partners.map(one => one.id),
        offers: args.Promo.Offers.map(one => one.id),
        label: args.Promo.Label,
        discount: args.Promo.Discount,
      }
      
      args.OurOffers.forEach( one => {
        // ignoring offer
        if (!one.Partners.includes(state.partnerId)) {
          return
        }
        
        state.offers.list.push({
          id: one.id,
          title: one.Title,
          iso: one.ISO || toIso(one.Title),
          price: one.Price,
          code: one.EcwidCode,
          description: one.Description,
          call2action: one.CallToAction,
          more2action: one.MoreAction,
          logoUrl: one.Logo.url,
          logoLazyUrl: one.Logo.formats?.thumbnail?.url ? one.Logo.formats.thumbnail.url : one.Logo.url,
          posterUrl: one.Poster.url,
          posterLazyUrl: one.Poster.formats?.thumbnail?.url ? one.Poster.formats.thumbnail.url : one.Poster.url,
          exampleTitle: one.ExampleTitle,
          exampleLink: one.ExampleLink,
          howItWorksTitle: one.HowItWorksTitle,
          howItWorksSteps: one.HowItWorksSteps.map(item => ({
            description: item.Description,
            pictureUrl: item.Picture.url,
            pictureLazyUrl: item.Picture.formats?.thumbnail?.url ? item.Picture.formats.thumbnail.url : item.Picture.url,
          })),
          deliveryTitle: one.DeliveryTitle,
          deliverySteps: one.DeliverySteps.map(item => ({
            description: item.Description,
            pictureUrl: item.Picture.url,
            pictureLazyUrl: item.Picture.formats?.thumbnail?.url ? item.Picture.formats.thumbnail.url : item.Picture.url,
          })),
          whyTitle: one.WhyTitle,
          whySteps: one.WhySteps.map(item => ({
            description: item.Description,
            pictureUrl: item.Picture.url,
            pictureLazyUrl: item.Picture.formats?.thumbnail?.url ? item.Picture.formats.thumbnail.url : item.Picture.url,
          })),
          after: {
            title: one.AfterTitle,
            description: one.AfterDescription,
            moreAction: one.AfterButton
          },
          project: {
            title: one.ProjectTitle,
            description: one.ProjectDescription,
            moreAction: one.ProjectButton,
            now: one.ProjectNow,
            after: one.ProjectAfter,
            steps: one.ProjectSteps.map(item => {
              // console.log(item)
              switch (item['__component']) {
                case 'project.q-picture':
                  return {
                    __component: 'QPicture',
                    id: item.id,
                    question: item.Question,
                    iso: item.ISO,
                    answers: item.Answers.map(ans => ({
                      id: ans.id,
                      label: ans.Label,
                      iso: ans.ISO || toIso(ans.Label),
                      pictureUrl: ans.Picture.url,
                      pictureLazyUrl: ans.Picture.formats?.thumbnail?.url ? ans.Picture.formats.thumbnail.url : ans.Picture.url
                    }))
                  }
                case 'project.q-picture-listing':
                  return {
                    __component: 'QPictureListing',
                    id: item.id,
                    question: item.Question,
                    iso: item.ISO || toIso(item.Question),
                    answers: item.Answers.map(ans => ({
                      id: ans.id,
                      label: ans.Label,
                      iso: ans.ISO || toIso(ans.Label),
                      pictures: ans.Pictures.map(pict => ({
                        pictureUrl: pict.url,
                        pictureLazyUrl: pict.formats?.thumbnail?.url ? pict.formats.thumbnail.url : pict.url
                      }))
                    }))
                  }
                case 'project.q-free':
                  return {
                    __component: 'QFree',
                    id: item.id,
                    question: item.Question,
                    iso: item.ISO || toIso(item.Question),
                    description: item.Description
                  }
                case 'project.q-text':
                  item.Picture = item.Picture || {}
                  return {
                    __component: 'QText',
                    id: item.id,
                    question: item.Question,
                    iso: item.ISO || toIso(item.Question),
                    pictureUrl: item.Picture.url,
                    pictureLazyUrl: item.Picture?.formats?.thumbnail?.url ? item.Picture.formats.thumbnail.url : item.Picture.url,
                    answers: item.Answers.map(ans => ({
                      id: ans.id,
                      label: ans.Label,
                      iso: ans.ISO || toIso(ans.Label),
                    }))
                  }
                default:
                  console.log('UnkComponent:'+item['__component'])
              }
            })
          }
        })
      })
    }
  },
  actions: {
    setCurrentOffer ({state, commit, dispatch}, iso) {
      if (!state.isLoaded) {
        setTimeout(() => {
          dispatch('setCurrentOffer', iso)
        }, 50)
      } else {
        commit('updateCurrentOffer', iso)
      }
    },
    async getQuizz () {
      return new Promise((resolve, reject) => {
        axios
        .get(`${K.strapiV2Url}/quizzes?UseIt=true`)
        .then( ({data}) => {
          data.sort(() => Math.random() - Math.random())
          resolve(data)
        })
        .catch (err => {
          reject(err)
        })
      })
    },
    async load ({commit, rootGetters}) {
      commit('setPartnerId', rootGetters['app/partnerId'])
      commit('setIsPartner', rootGetters['app/isPartner'])
      axios
      .get(`${K.strapiV2Url}/web-app`)
      .then( ({data}) => {
        commit('setWebApp', data)
      })
      .catch (err => {
        console.log(err)
      })
      .finally(() => {
        commit('isLoaded')
      })
      axios
      .get(`${K.strapiV2Url}/contact`)
      .then( ({data}) => {
        commit('setContact', data)
      })
      .catch (err => {
        console.log(err)
      })
      axios
      .get(`${K.strapiV2Url}/faqs?_sort=Index:ASC`)
      .then( ({data}) => {
        commit('setFaqs', data)
      })
      .catch (err => {
        console.log(err)
      })
    }
  }
}